import React, { useState } from 'react';
import styled from 'styled-components';

import MusicWaveIcon from '@components/dataDisplay/Icons/MusicWaveIcon';
import { useRecoilState } from 'recoil';
import { playerOpenState } from '@atom/setting/jukebox';

const MusicButtonWrap = styled.button`
  border-radius: var(--buttonBorderRadius);
  transition: background-color 0.3s;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    background-color: var(--inkColor);
  }
`;

interface Props {
  style?: any;
  color?: string;
  isShow?: boolean;
}

function MusicButton({ style, color, isShow = true }: Props) {
  const [isMusicOn, setMusicOn] = useState(true);
  const [open, setOpen] = useRecoilState(playerOpenState);

  function handleClickMusic(e) {
    e.stopPropagation();
    setOpen(!open);
  }

  if (!isShow) return null;

  return (
    <>
      <MusicButtonWrap onClick={handleClickMusic} style={style}>
        <MusicWaveIcon isMusicOn={isMusicOn} color={color} />
      </MusicButtonWrap>
    </>
  );
}

export default React.memo(MusicButton);
